"use client"

import React, { FC } from "react";
import rightImg from "images/about1.jpg";
import rightImg1 from "images/about2.jpg";
import rightImg2 from "images/about3.jpg";
import NcImage from "shared/NcImage/NcImage";
import Badge from "shared/Badge/Badge";

export interface SectionAboutusProps {
  className?: string;
}

const SectionAboutus: FC<SectionAboutusProps> = ({ className = "" }) => {
  return (
    <div className={`nc-SectionAboutus bg-white ${className}`} data-nc-id="SectionAboutus">
      {/* Header Section */}
      

      {/* Section 1: Professional Services */}
      <div className="px-4 sm:px-6 lg:px-8 py-12 sm:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
            {/* Text Content */}
            <div className="order-2 lg:order-1">
              <div className="mb-4">
                <span className="inline-block px-3 py-1 bg-amber-500/10 rounded-full border border-amber-500/20 text-xs font-semibold text-amber-600">
                  Excellence
                </span>
              </div>
              <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-6 leading-tight">
                Professional Services
              </h2>
              <p className="text-base text-gray-600 leading-relaxed mb-6">
                Europe Tours & Travels are ground handlers and take care of all aspects of travel bookings, including hotels, guesthouses, apartments, transport, car hire, coach hire, sightseeing, special interest travel, FIT and group travel, sport tours and conferences.
              </p>
              <p className="text-base text-gray-600 leading-relaxed">
                All aspects of the bookings are custom made specially for your clients, and we offer services for both the leisure and corporate market. Think of us as your 'One Stop Travel Shop,' where the service is always excellent.
              </p>
            </div>
            {/* Image */}
            <div className="order-1 lg:order-2">
              <div className="rounded-xl overflow-hidden shadow-lg">
                <NcImage src={rightImg} className="w-full h-auto object-cover" />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Section 2: We Got You Covered */}
      <div className="px-4 sm:px-6 lg:px-8 py-12 sm:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
            {/* Image */}
            <div>
              <div className="rounded-xl overflow-hidden shadow-lg">
                <NcImage src={rightImg1} className="w-full h-auto object-cover" />
              </div>
            </div>
            {/* Text Content */}
            <div>
              <div className="mb-4">
                <span className="inline-block px-3 py-1 bg-amber-500/10 rounded-full border border-amber-500/20 text-xs font-semibold text-amber-600">
                  Support
                </span>
              </div>
              <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-6 leading-tight">
                We Got You Covered!
              </h2>
              <p className="text-base text-gray-600 leading-relaxed mb-6">
                Our strong relationships with Inbound and Outbound Travel Agents are testament to our professionalism. We always include the extras that make a trip so special, including sightseeing tickets, dinner reservations and theatre tickets. Our staff are all travel specialists and will look after you, the Travel Agent, from start to finish.
              </p>
              <p className="text-base text-gray-600 leading-relaxed mb-6">
                At Europe Tours & Travels we offer 24 hour support to you, the Agent, and to your clients. Our staff members will always be on hand to take your bookings, for last minute bookings and for changes to existing bookings.
              </p>
              <p className="text-base text-gray-600 leading-relaxed">
                We are competitively priced with our large buying power throughout Europe and only work with the best and most professional people in the travel industry.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Section 3: Why Choose Us */}
      <div className="px-4 sm:px-6 lg:px-8 py-12 sm:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-start">
            {/* Text Content */}
            <div className="order-2 lg:order-1">
              <div className="mb-4">
                <span className="inline-block px-3 py-1 bg-amber-500/10 rounded-full border border-amber-500/20 text-xs font-semibold text-amber-600">
                  Why Us
                </span>
              </div>
              <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-8 leading-tight">
                Why Choose Us?
              </h2>
              
              <ul className="space-y-1">
                {[
                  "Offer you one platform where you can book all your travel arrangements.",
                  "Ensure you are getting the best partners in Europe, regarding all aspects of the travel booking.",
                  "Respond immediately with confirmations, invoices, vouchers and/or the itinerary.",
                  "Provide reference numbers and contact details for all aspect of the booking.",
                  "Keep on top of travel trends",
                  "Offer you, the Travel Agent, the best possible prices and competitive service.",
                  "Safeguard you, the Travel Agent, as you are and always will be our primary clients.",
                  "Grow our business and our range of travel services.",
                  "Be your 'One Stop Travel Shop.'",
                ].map((item, idx) => (
                  <li key={idx} className="flex items-start space-x-4 p-3 rounded-lg hover:bg-gray-50 transition-colors duration-200">
                    <div className="flex-shrink-0">
                      <Badge name={String(idx + 1).padStart(2, "0")} />
                    </div>
                    <span className="font-medium text-gray-700 leading-relaxed pt-1">
                      {item}
                    </span>
                  </li>
                ))}
              </ul>
            </div>
            
            {/* Image */}
            <div className="order-1 lg:order-2">
              <div className="rounded-xl overflow-hidden shadow-lg">
                <NcImage src={rightImg2} className="w-full h-auto object-cover" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SectionAboutus;
